module.exports = __webpack_public_path__ + "img/图片17.a1ada0b6.png";